module.exports = __webpack_public_path__ + "img/premiseTitleImg.4609deaf.png";